// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.loginFormHeader {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.5rem 0 1.25rem;
  padding: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #222;
  text-align: left;
}
.loginFormHeader svg {
  flex-shrink: 0;
  color: #515592;
}

.loginForm {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem auto;
  padding: 1.5rem;
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}
.loginForm .form-group {
  display: flex;
  flex-direction: column;
}
.loginForm .form-group label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.6rem;
  font-weight: 500;
  color: #555;
  font-size: 0.95rem;
}
.loginForm .form-group label svg {
  flex-shrink: 0;
  color: #515592;
  opacity: 0.7;
}
.loginForm .form-group input {
  display: block;
  width: 100%;
  padding: 0.8rem 1rem;
  font-size: 1rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.75rem;
  transition: all 0.3s ease;
}
.loginForm .form-group input:focus {
  outline: none;
  border-color: #515592;
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.1);
}
.loginForm .phone-input-wrap {
  position: relative;
}
.loginForm .phone-input-placeholder {
  position: absolute;
  top: 1px;
  right: 1.5px;
  bottom: 1px;
  left: 3.5rem;
  z-index: 11;
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 0 0.9rem 0.9rem 0;
  color: #999;
  font-size: 1rem;
  white-space: nowrap;
  pointer-events: none;
}
.loginForm .phone-input-placeholder.error {
  background-color: #fdf1f1;
  color: #f70d1a;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.loginForm input.error,
.loginForm .form-control.error {
  border-color: #f70d1a !important;
  background-color: rgba(247, 13, 26, 0.05) !important;
}
.loginForm input.error::placeholder,
.loginForm .form-control.error::placeholder {
  color: #f70d1a;
  opacity: 1;
}
.loginForm input.error:focus,
.loginForm .form-control.error:focus {
  border-color: #f70d1a !important;
  box-shadow: 0 0 0 4px rgba(247, 13, 26, 0.1);
}
.loginForm .phone-input {
  position: relative;
  z-index: 10;
}
.loginForm .phone-input .form-control {
  width: 100%;
  height: 3.5rem;
  font-size: 1rem !important;
  border-radius: 0.9rem !important;
}
.loginForm .phone-input .flag-dropdown {
  padding-left: 0.5rem;
  background: transparent !important;
  border: none !important;
  border-radius: 0.9rem 0 0 0.9rem !important;
}
.loginForm .phone-input .flag-dropdown .selected-flag {
  border-radius: 0.9rem 0 0 0.9rem;
}
.loginForm .phone-input .flag-dropdown .selected-flag:hover, .loginForm .phone-input .flag-dropdown .selected-flag:focus {
  background-color: transparent;
}
.loginForm .phone-input .flag-dropdown .selected-flag .arrow {
  border-top-color: #999;
  transition: transform 0.2s ease;
}
.loginForm .phone-input .flag-dropdown .selected-flag.open .arrow {
  border-top-color: #515592;
  transform: rotate(180deg);
}
.loginForm .phone-input input {
  padding-left: 3.5rem !important;
}
.loginForm .phone-input .country-list {
  top: calc(100% + 0.5rem);
  left: 0;
  width: 320px;
  max-width: calc(100vw - 3rem);
  max-height: 260px;
  padding: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #eee;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  z-index: 20;
  animation: dropdownIn 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}
.loginForm .phone-input .country-list::-webkit-scrollbar {
  width: 6px;
}
.loginForm .phone-input .country-list::-webkit-scrollbar-track {
  background: transparent;
}
.loginForm .phone-input .country-list::-webkit-scrollbar-thumb {
  background-color: rgba(81, 85, 146, 0.25);
  border-radius: 10px;
}
.loginForm .phone-input .country-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(81, 85, 146, 0.4);
}
.loginForm .phone-input .country-list .search {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.5rem 0.75rem;
  background-color: #ffffff;
}
.loginForm .phone-input .country-list .search .search-box {
  width: 100%;
  margin: 0;
  padding: 0.6rem 0.9rem;
  font-size: 0.9rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.6rem;
  transition: all 0.2s ease;
}
.loginForm .phone-input .country-list .search .search-box:focus {
  outline: none;
  border-color: #515592;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.1);
}
.loginForm .phone-input .country-list .country {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.75rem;
  border-radius: 0.6rem;
  transition: background-color 0.15s ease;
}
.loginForm .phone-input .country-list .country .flag {
  margin-right: 0.75rem;
  flex-shrink: 0;
}
.loginForm .phone-input .country-list .country .country-name {
  color: #333;
  font-size: 0.95rem;
}
.loginForm .phone-input .country-list .country .dial-code {
  margin-left: 0.4rem;
  color: #999;
  font-size: 0.9rem;
}
.loginForm .phone-input .country-list .country:hover {
  background-color: rgba(81, 85, 146, 0.08);
}
.loginForm .phone-input .country-list .country.highlight {
  background-color: rgba(81, 85, 146, 0.12);
}
.loginForm .phone-input .country-list .country.highlight .country-name {
  font-weight: 500;
  color: #515592;
}
.loginForm .phone-input .country-list .divider {
  margin: 0.4rem 0.25rem;
  border-bottom: 1px solid #f0f0f0;
}
.loginForm .phone-input .country-list .no-entries-message {
  padding: 0.75rem;
  color: #999;
  font-size: 0.9rem;
  text-align: center;
}
.loginForm button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3rem);
  background: linear-gradient(to right, #1d2239, #4657a2, #1d2239);
  color: #ffffff;
  border-radius: 2rem;
  border: none;
  text-transform: uppercase;
  font-size: 1.1rem;
  line-height: 1.3rem;
  padding: 1rem 0;
  margin: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 200px;
  height: 3rem;
  margin: 0 auto;
  padding: 0;
  background: #515592 !important;
  color: #ffffff;
  font-family: "Roboto", sans-serif !important;
  font-weight: 500 !important;
  font-size: 1.1rem;
  letter-spacing: 0.2px;
  border: none;
  border-radius: 100px;
  box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none !important;
}
.loginForm button:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.loginForm button:disabled {
  background: rgb(200, 200, 200);
}
.loginForm button:hover {
  filter: brightness(1.05);
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);
}
.loginForm button:active {
  filter: brightness(0.95);
  transform: translateY(1px);
  box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);
}

@keyframes dropdownIn {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.loginBottomLink {
  margin-top: 1.5rem;
  text-align: center;
  color: #777;
  font-size: 0.9rem;
}
.loginBottomLink a {
  padding: 0.2rem 0.5rem;
  color: #515592;
  font-weight: 600;
  text-decoration: none;
  border-radius: 0.4rem;
  transition: background 0.2s;
}
.loginBottomLink a:hover {
  background: rgba(81, 85, 146, 0.1);
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/PhoneInput/PhoneNumberInput.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_app-button.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAqEF;AAnEE;EACE,cAAA;EACA,cAfY;AAoFhB;;AAjEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,yBC3BM;ED4BN,mBAAA;EACA,2CAAA;AAoEF;AAlEE;EACE,aAAA;EACA,sBAAA;AAoEJ;AAlEI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAoEN;AAlEM;EACE,cAAA;EACA,cA5CQ;EA6CR,YAAA;AAoER;AAhEI;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;AAkEN;AAhEM;EACE,aAAA;EACA,qBA7DQ;EA8DR,yBChEA;EDiEA,4CAAA;AAkER;AA7DE;EACE,kBAAA;AA+DJ;AA5DE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AA8DJ;AA5DI;EACE,yBAAA;EACA,cCxFM;EDyFN,iBAAA;EACA,gBAAA;EACA,uBAAA;AA8DN;AA1DE;;EAEE,gCAAA;EACA,oDAAA;AA4DJ;AA1DI;;EACE,cCrGM;EDsGN,UAAA;AA6DN;AA1DI;;EACE,gCAAA;EACA,4CAAA;AA6DN;AAzDE;EACE,kBAAA;EACA,WAAA;AA2DJ;AAzDI;EACE,WAAA;EACA,cAAA;EACA,0BAAA;EACA,gCAAA;AA2DN;AAxDI;EACE,oBAAA;EACA,kCAAA;EACA,uBAAA;EACA,2CAAA;AA0DN;AAxDM;EACE,gCAAA;AA0DR;AAxDQ;EAEE,6BAAA;AAyDV;AAtDQ;EACE,sBAAA;EACA,+BAAA;AAwDV;AArDQ;EACE,yBAhJM;EAiJN,yBAAA;AAuDV;AAlDI;EACE,+BAAA;AAoDN;AAjDI;EACE,wBAAA;EACA,OAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,yBCnKE;EDoKF,sBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,WAAA;EACA,yDAAA;AAmDN;AAjDM;EACE,UAAA;AAmDR;AAhDM;EACE,uBAAA;AAkDR;AA/CM;EACE,yCAAA;EACA,mBAAA;AAiDR;AA/CQ;EACE,wCAAA;AAiDV;AA7CM;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,8BAAA;EACA,yBCjMA;ADgPR;AA7CQ;EACE,WAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;AA+CV;AA7CU;EACE,aAAA;EACA,qBA7MI;EA8MJ,yBChNJ;EDiNI,4CAAA;AA+CZ;AA1CM;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uCAAA;AA4CR;AA1CQ;EACE,qBAAA;EACA,cAAA;AA4CV;AAzCQ;EACE,WAAA;EACA,kBAAA;AA2CV;AAxCQ;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;AA0CV;AAvCQ;EACE,yCAAA;AAyCV;AAtCQ;EACE,yCAAA;AAwCV;AAtCU;EACE,gBAAA;EACA,cApPI;AA4RhB;AAnCM;EACE,sBAAA;EACA,gCAAA;AAqCR;AAlCM;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAoCR;AA/BE;EExQA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gEDDe;ECEf,cDPM;ECQN,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EF8PE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,8BAAA;EACA,cCrRI;EDsRJ,4CAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,8CAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;AA6CJ;AE7TE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AF+TJ;AE7TE;EACE,8BDdO;AD6UX;AAnDI;EACE,wBAAA;EACA,2BAAA;EACA,8CAAA;AAqDN;AAlDI;EACE,wBAAA;EACA,0BAAA;EACA,6CAAA;AAoDN;;AA/CA;EACE;IACE,UAAA;IACA,uCAAA;EAkDF;EAhDA;IACE,UAAA;IACA,iCAAA;EAkDF;AACF;AA/CA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAiDF;AA/CE;EACE,sBAAA;EACA,cAhUY;EAiUZ,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;AAiDJ;AA/CI;EACE,kCAAA;EACA,qBAAA;AAiDN","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme';\n\n$brand_primary: #515592;\n\n.loginFormHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0.5rem 0 1.25rem;\n  padding: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #222;\n  text-align: left;\n\n  svg {\n    flex-shrink: 0;\n    color: $brand_primary;\n  }\n}\n\n.loginForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin: 1rem auto;\n  padding: 1.5rem;\n  background-color: $white;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n    label {\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n      margin-bottom: 0.6rem;\n      font-weight: 500;\n      color: #555;\n      font-size: 0.95rem;\n\n      svg {\n        flex-shrink: 0;\n        color: $brand_primary;\n        opacity: 0.7;\n      }\n    }\n\n    input {\n      display: block;\n      width: 100%;\n      padding: 0.8rem 1rem;\n      font-size: 1rem;\n      background-color: #f9f9f9;\n      border: 1.5px solid #eee;\n      border-radius: 0.75rem;\n      transition: all 0.3s ease;\n\n      &:focus {\n        outline: none;\n        border-color: $brand_primary;\n        background-color: $white;\n        box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.1);\n      }\n    }\n  }\n\n  .phone-input-wrap {\n    position: relative;\n  }\n\n  .phone-input-placeholder {\n    position: absolute;\n    top: 1px;\n    right: 1.5px;\n    bottom: 1px;\n    left: 3.5rem;\n    z-index: 11;\n    display: flex;\n    align-items: center;\n    background-color: #f9f9f9;\n    border-radius: 0 0.9rem 0.9rem 0;\n    color: #999;\n    font-size: 1rem;\n    white-space: nowrap;\n    pointer-events: none;\n\n    &.error {\n      background-color: #fdf1f1;\n      color: $errorText;\n      font-size: 0.9rem;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  input.error,\n  .form-control.error {\n    border-color: $errorText !important;\n    background-color: rgba($errorText, 0.05) !important;\n\n    &::placeholder {\n      color: $errorText;\n      opacity: 1;\n    }\n\n    &:focus {\n      border-color: $errorText !important;\n      box-shadow: 0 0 0 4px rgba($errorText, 0.1);\n    }\n  }\n\n  .phone-input {\n    position: relative;\n    z-index: 10;\n\n    .form-control {\n      width: 100%;\n      height: 3.5rem;\n      font-size: 1rem !important;\n      border-radius: 0.9rem !important;\n    }\n\n    .flag-dropdown {\n      padding-left: 0.5rem;\n      background: transparent !important;\n      border: none !important;\n      border-radius: 0.9rem 0 0 0.9rem !important;\n\n      .selected-flag {\n        border-radius: 0.9rem 0 0 0.9rem;\n\n        &:hover,\n        &:focus {\n          background-color: transparent;\n        }\n\n        .arrow {\n          border-top-color: #999;\n          transition: transform 0.2s ease;\n        }\n\n        &.open .arrow {\n          border-top-color: $brand_primary;\n          transform: rotate(180deg);\n        }\n      }\n    }\n\n    input {\n      padding-left: 3.5rem !important;\n    }\n\n    .country-list {\n      top: calc(100% + 0.5rem);\n      left: 0;\n      width: 320px;\n      max-width: calc(100vw - 3rem);\n      max-height: 260px;\n      padding: 0.5rem;\n      background-color: $white;\n      border: 1px solid #eee;\n      border-radius: 1rem;\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n      overflow-y: auto;\n      z-index: 20;\n      animation: dropdownIn 0.18s cubic-bezier(0.16, 1, 0.3, 1);\n\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: transparent;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: rgba(81, 85, 146, 0.25);\n        border-radius: 10px;\n\n        &:hover {\n          background-color: rgba(81, 85, 146, 0.4);\n        }\n      }\n\n      .search {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        padding: 0.5rem 0.5rem 0.75rem;\n        background-color: $white;\n\n        .search-box {\n          width: 100%;\n          margin: 0;\n          padding: 0.6rem 0.9rem;\n          font-size: 0.9rem;\n          background-color: #f9f9f9;\n          border: 1.5px solid #eee;\n          border-radius: 0.6rem;\n          transition: all 0.2s ease;\n\n          &:focus {\n            outline: none;\n            border-color: $brand_primary;\n            background-color: $white;\n            box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.1);\n          }\n        }\n      }\n\n      .country {\n        display: flex;\n        align-items: center;\n        padding: 0.65rem 0.75rem;\n        border-radius: 0.6rem;\n        transition: background-color 0.15s ease;\n\n        .flag {\n          margin-right: 0.75rem;\n          flex-shrink: 0;\n        }\n\n        .country-name {\n          color: #333;\n          font-size: 0.95rem;\n        }\n\n        .dial-code {\n          margin-left: 0.4rem;\n          color: #999;\n          font-size: 0.9rem;\n        }\n\n        &:hover {\n          background-color: rgba(81, 85, 146, 0.08);\n        }\n\n        &.highlight {\n          background-color: rgba(81, 85, 146, 0.12);\n\n          .country-name {\n            font-weight: 500;\n            color: $brand_primary;\n          }\n        }\n      }\n\n      .divider {\n        margin: 0.4rem 0.25rem;\n        border-bottom: 1px solid #f0f0f0;\n      }\n\n      .no-entries-message {\n        padding: 0.75rem;\n        color: #999;\n        font-size: 0.9rem;\n        text-align: center;\n      }\n    }\n  }\n\n  button {\n    @include app-button;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    max-width: 200px;\n    height: 3rem;\n    margin: 0 auto;\n    padding: 0;\n    background: $brand_primary !important;\n    color: $white;\n    font-family: 'Roboto', sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 1.1rem;\n    letter-spacing: 0.2px;\n    border: none;\n    border-radius: 100px;\n    box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-transform: none !important;\n\n    &:hover {\n      filter: brightness(1.05);\n      transform: translateY(-1px);\n      box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);\n    }\n\n    &:active {\n      filter: brightness(0.95);\n      transform: translateY(1px);\n      box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);\n    }\n  }\n}\n\n@keyframes dropdownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.loginBottomLink {\n  margin-top: 1.5rem;\n  text-align: center;\n  color: #777;\n  font-size: 0.9rem;\n\n  a {\n    padding: 0.2rem 0.5rem;\n    color: $brand_primary;\n    font-weight: 600;\n    text-decoration: none;\n    border-radius: 0.4rem;\n    transition: background 0.2s;\n\n    &:hover {\n      background: rgba(81, 85, 146, 0.1);\n      text-decoration: none;\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin app-button() {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 3rem);\n  background: $buttonLinearBg;\n  color: $white;\n  border-radius: 2rem;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n  padding: 1rem 0;\n  margin: 1rem 1.5rem;\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n  &:disabled {\n    background: $disabled;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
